var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.options,"searchable":false,"showNoOptions":false,"max-height":125,"allow-empty":false,"disabled":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }